<div id="producte-form" ng-cloak>

      <itec-form 
      	name="ctrl.formulari.nom"
      	fields="ctrl.formulari.camps"
      	ng-model="ctrl.producte"
      	ng-submit-function="ctrl.formulari.func()"
      	errors="ctrl.errors"
        submit-button-text="DEFAULT_GUARDAR"
        backbutton="true"
        backbuttonfunction="ctrl.back()"
        >

        
      </itec-form>
</div>
